import { useAuthContext } from "../../../../contexts/AuthContext";
import { HomepageEnergyCharts } from "./HomepageCharts/HomepageEnergyCharts";
import { HomepageEnvironmentCharts } from "./HomepageCharts/HomepageEnvironmentCharts";
import { HomepageGreenSpaces } from "./HomepageCharts/HomepageGreenSpaces";
import { HomepageParkingCharts } from "./HomepageCharts/HomepageParkingCharts";
import { HomepageWaterCharts } from "./HomepageCharts/HomepageWaterCharts";

export const HomepageCharts = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
            <HomepageParkingCharts/>
            <HomepageEnergyCharts/>
            <HomepageGreenSpaces />
            <HomepageWaterCharts/>
            <HomepageEnvironmentCharts />
        </div>
    );
};